import React from "react";

import { Text } from "@mbank-design/design-system/components";
import {
  FontWeight,
  FontSize,
  LineHeight,
  FontColor
} from "@mbank-design/design-system/design-tokens/general/typography";

import "../../../assets/styles/components/question-text-section-container.scss";
import { CarsDisclaimers } from "../../../constants/carsListDisclaimers";

/**
 * @param {object} props
 * @param {string} props.pathname
 * @param {{mainTextLiterals: {mainTitle: string, mainText: string}, subTextLiterals: {subLiteralTitle: string, subLiteralText: string}[]}} props.dynamicSeoTexts
 */

const DynamicQuestionTextSection = ({ pathname, dynamicSeoTexts }) => {
  const bodyTypeLinks = ["/sedan", "/hatchback", "/kombi", "/suv", "/bus", "/van","/coupe"];

  const segments = pathname.split("/").filter(Boolean);
  let params = {
    carState: null,
    fuelType: null,
    make: null,
    model: null,
    bodyType: null
  };
  const carStateMap = {
    "samochody-poleasingowe": "Samochody poleasingowe",
    "samochody-nowe": "Nowe samochody",
    "samochody-elektryczne": "Samochody elektryczne"
  };

  segments.forEach((segment) => {
    if (carStateMap[segment]) {
      if (segment === "samochody-elektryczne") {
        params.fuelType = carStateMap[segment];
      } else {
        params.carState = carStateMap[segment];
      }
    } else {
      const makeAndModel = segment.split("-");
      if (makeAndModel.length > 1) {
        if (makeAndModel[0] === "land" || makeAndModel[0] === "mercedes" || makeAndModel[0] === "alfa" || makeAndModel[0] === "aston") {
          params.make = makeAndModel[0] + "-" + makeAndModel[1];
          params.model = makeAndModel.slice(2).join("-") || null;
        } else {
          params.make = makeAndModel[0];
          params.model = makeAndModel.slice(1).join("-") || null;
        }
      } else {
        params.make = makeAndModel[0];
        params.model = null;
      }
    }
  });
  if (
    !pathname.includes("/lista-pojazdow") &&
    params.model &&
    pathname &&
    !pathname.startsWith("/nowe-samochody") &&
    !pathname.startsWith("/samochody-poleasingowe")
  ) {
    const SEO_KEY = `${params.make}_${params.model}`.toUpperCase().replace(/-/g, "_");

    return (
      <div className="question-text-section-container mleasing-main-container">
        {CarsDisclaimers[SEO_KEY] &&
          CarsDisclaimers[SEO_KEY].ADDITIONAL_TEXTS.map((paragraph, index) => {
            return (
              <div key={index}>
                <Text
                  as="h2"
                  styledAs={"h5"}
                  fontSize={FontSize.SIZE_24}
                  lineHeight={LineHeight.HEIGHT_32}
                  dangerouslySetInnerHTML={{ __html: paragraph.title }}
                ></Text>
                <Text
                  as="p"
                  fontSize={FontSize.SIZE_12}
                  lineHeight={LineHeight.HEIGHT_16}
                  fontWeight={FontWeight.WEIGHT_600}
                  color={"doveGrayUI"}
                  dangerouslySetInnerHTML={{ __html: paragraph.text }}
                ></Text>
              </div>
            );
          })}
      </div>
    );
  } else if ((pathname.includes("/marki/") || bodyTypeLinks.includes(pathname)) && !params.model) {
    return (
      <div className="question-text-section-container mleasing-main-container">
        {dynamicSeoTexts.subTextLiterals.map((subLiteral, index) => {
          return (
            <div key={index}>
              <Text
                as="h2"
                styledAs={"h5"}
                fontSize={FontSize.SIZE_24}
                lineHeight={LineHeight.HEIGHT_32}
                dangerouslySetInnerHTML={{ __html: subLiteral.subLiteralTitle }}
              ></Text>
              <Text
                as="p"
                fontSize={FontSize.SIZE_12}
                lineHeight={LineHeight.HEIGHT_16}
                fontWeight={FontWeight.WEIGHT_600}
                color={"doveGrayUI"}
                dangerouslySetInnerHTML={{ __html: subLiteral.subLiteralText }}
              ></Text>
            </div>
          );
        })}
      </div>
    );
  } else if (
    !pathname.includes("/lista-pojazdow") &&
    params.make &&
    pathname &&
    (pathname.includes("/nowe-samochody") || pathname.includes("/samochody-poleasingowe"))
  ) {
    const prefix = pathname.includes("/nowe-samochody") ? "NEW" : "AFTERLEASE";
    const SEO_KEY = params.model 
      ? `${prefix}_${params.make}_${params.model}`.toUpperCase().replace(/-/g, "_")
      : `${prefix}_${params.make}`.toUpperCase().replace(/-/g, "_");
    return (
      <div className="question-text-section-container mleasing-main-container">
        {CarsDisclaimers[SEO_KEY] && CarsDisclaimers[SEO_KEY].ADDITIONAL_TEXTS.map((paragraph, index) => {
          return (
            <div key={index}>
              <Text
                as="h2"
                styledAs={"h5"}
                fontSize={FontSize.SIZE_24}
                lineHeight={LineHeight.HEIGHT_32}
                dangerouslySetInnerHTML={{ __html: paragraph.title }}
              ></Text>
              <Text
                as="p"
                fontSize={FontSize.SIZE_12}
                lineHeight={LineHeight.HEIGHT_16}
                fontWeight={FontWeight.WEIGHT_600}
                color={"doveGrayUI"}
                dangerouslySetInnerHTML={{ __html: paragraph.text }}
              ></Text>
            </div>
          );
        })}
      </div>
    );
  }
};

export default DynamicQuestionTextSection;
